module.exports = __webpack_public_path__ + "img/1.030cef32.jpg";